// extracted by mini-css-extract-plugin
export var discard = "_24-4";
export var muiTooltipTooltip = "_24-6";
export var notificationBar = "_24-3";
export var notificationContainer = "_24-2";
export var saveButtonHoverSlotWrapper = "_24-5";
export var show = "_24-1";
export var spacer = "_24-0";